export enum CampaignOfferType {
  Item,
  Restaurant,
}
